import { useEffect, useState } from "react";
import API from "../../services/api";
import "./calendar.css";

export default function TeacherAttendanceCalendar() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [month, setMonth] = useState(
    new Date().toISOString().slice(0, 7), // YYYY-MM
  );
  const [records, setRecords] = useState([]);

  // ================= LOAD CALENDAR DATA =================
  const loadCalendar = async () => {
    try {
      const res = await API.get(
        `/school-admin/teacher-attendance/calendar/?month=${month}`,
        {
          headers: { "X-SCHOOL-ID": school.school.id },
        },
      );

      setRecords(res.data.records || []);
    } catch (err) {
      console.error("Calendar load error", err);
      alert("Failed to load calendar data");
    }
  };

  useEffect(() => {
    loadCalendar();
  }, [month]);

  // ================= CALENDAR HELPERS =================
  const [year, monthNum] = month.split("-").map(Number);
  const daysInMonth = new Date(year, monthNum, 0).getDate();

  const getDayData = (day) => {
    const fullDate = `${month}-${String(day).padStart(2, "0")}`;
    return records.filter((r) => r.date === fullDate);
  };

  // ================= COLOR LOGIC =================
const getColor = (r) => {

  // LEAVE COLORS FIRST
  if (r.status === "leave") {

    if (r.approval_status === "approved") {
      return "blue";
    }

    if (r.approval_status === "pending") {
      return "yellow";
    }

    if (r.approval_status === "rejected") {
      return "red";
    }
  }

  // NORMAL ATTENDANCE
  if (r.status === "present") {
    return "green";
  }

  if (r.status === "absent") {
    return "red";
  }

  return "grey";
};

  return (

      <div className="calendar-container">
        {/* HEADER */}
        <div className="calendar-header">
          <h2>Teacher Attendance Calendar</h2>
          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
        </div>
        {/* HEADER */}

        {/* 🔹 LEGEND */}
        <div className="calendar-legend">
          <div className="legend-item">
            <span className="legend-dot green"></span> Present
          </div>
          <div className="legend-item">
            <span className="legend-dot red"></span> Absent
          </div>
          <div className="legend-item">
            <span className="legend-dot blue"></span> Approved Leave
          </div>
          <div className="legend-item">
            <span className="legend-dot yellow"></span> Pending Leave
          </div>
        </div>
        {/* CALENDAR GRID */}
        <div className="calendar-grid">
          {[...Array(daysInMonth)].map((_, i) => {
            const day = i + 1;
            const dayData = getDayData(day);

            return (
              <div key={day} className="calendar-cell">
                <span className="day-number">{day}</span>

                {dayData.map((r) => (
                  <div
                    key={r.id}
                    className={`event ${getColor(r)}`}
                    title={`${r.teacher} - ${
                      r.status === "leave"
                        ? r.approval_status === "approved"
                          ? "Approved Leave"
                          : "Pending Leave"
                        : r.status
                    }`}
                  >
                    {r.teacher}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>

  );
}
